export const TASKS_VIEW_TYPES = {
  TABLE: 'table',
  LIST: 'list',
  CALENDAR: 'calendar',
  KANBAN: 'kanban',
};
